<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('preInvoice.academic') }}</legend>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.mainProgram')
          }}</label>
          <div class="col-md-8">
            <input
              type="text"
              class="form-control-plaintext"
              readonly
              :value="
                studentInfo
                  ? studentInfo.academic_class.main_program.acp_name_foreign
                  : ''
              "
            />
            <div class="validate" v-if="errors.has('acp_id')">
              {{ errors.first('acp_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.subProgram')
          }}</label>
          <div class="col-md-8">
            <input
              type="text"
              class="form-control-plaintext"
              readonly
              :value="
                studentInfo
                  ? studentInfo.academic_class.sub_program.acps_name_foreign
                  : ''
              "
            />
            <div class="validate" v-if="errors.has('acps_id')">
              {{ errors.first('acps_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.newAcademicTerm')
          }}</label>
          <div class="col-md-8">
            <treeselect
              :options="termOptions"
              :load-options="loadTermOptions"
              :placeholder="$t('select')"
              :clearable="false"
              v-model="model.ac_term_id"
            />
            <div class="validate" v-if="errors.has('ac_term_id')">
              {{ errors.first('ac_term_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.newGrade')
          }}</label>
          <div class="col-md-8">
            <treeselect
              :options="gradeOptions"
              :load-options="loadGradeOptions"
              :placeholder="$t('select')"
              :clearable="false"
              v-model="model.grade_id"
            />
            <div class="validate" v-if="errors.has('grade_id')">
              {{ errors.first('grade_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4">{{
            $t('preInvoice.remark')
          }}</label>
          <div class="col-md-8">
            <textarea class="form-control" rows="3" v-model="model.remark"></textarea>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'preInvoiceAcademic',
  props: ['value', 'studentInfo', 'validate'],
  data() {
    return {
      model: {},
      termOptions: null,
      gradeOptions: [],
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('preInvoice', ['getAcademicTerm', 'getGradeByLevel']),
    async loadTermOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.studentInfo) {
          let response = await this.getAcademicTerm({
            page: -1,
            filter: { acps_id: this.studentInfo.academic_class.acps_id, ac_status_id: 3 }
          })
          const orderLevelSelected = this.studentInfo.academic_class
            .academic_term.term_order

          this.termOptions = response.data
            .filter(f => f.term_order >= orderLevelSelected)
            .map(el => ({
              id: el.ac_term_id,
              label: el.term_name
            }))
        }
      }
    },
    async loadGradeOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.studentInfo) {
          const nextGrade =
            this.studentInfo.academic_class.grade.next_grade_id || 0
          let response = await this.getGradeByLevel({
            fields: {
              academic_program_level_grades:
                'grade_id,grade_name_foreign,next_grade_id'
            },
            page: -1,
            filter: {
              'academic_program_level_grades.level_id': this.studentInfo.academic_class.grade.level_id,
              grade_id:
                nextGrade + ',' + this.studentInfo.academic_class.grade.grade_id
            }
          })
          this.gradeOptions = response.data.map(el => ({
            id: el.next_grade_id,
            label: el.next_grade_name
          }))
        }
      }
    }
  },
  watch: {
    studentInfo: function() {
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.termOptions = null
      this.gradeOptions = null
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
